function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP delivery
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import Info from '../info/Info';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deliveryInt, postage } from '../../actions/index';
import { DELIVERY_MSG, IMAGE_PATH_PREFIX, POSTAGE } from '../../data/Data';
import './Delivery.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Delivery extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        deliveryInt
      } = this.props;
      const {
        focus
      } = this.state;
      if (focus && key === 'Enter') {
        deliveryInt(focus);
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", focus => {
      this.setState({
        focus
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: ''
      });
    });
    /**
     * Select Australian / International
     */
    _defineProperty(this, "select", value => {
      const {
        setPostage,
        deliveryInt
      } = this.props;
      deliveryInt(value);
      if (value === 'Australian') {
        setPostage(POSTAGE[0]);
      } else {
        setPostage(POSTAGE[1]);
      }
    });
    this.state = {
      focus: ''
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      addresses
    } = this.props;
    const {
      licenceDelivery
    } = addresses;
    let buttons = [];
    const options = [{
      default: true,
      checked: licenceDelivery === 'Australian' ? true : false,
      title: 'Australian address',
      value: 'Australian',
      icon: /*#__PURE__*/_jsx("img", {
        src: `${IMAGE_PATH_PREFIX}/australia.png`,
        alt: "Icon of Australia"
      })
    }, {
      default: false,
      checked: licenceDelivery === 'International' ? true : false,
      title: 'International address',
      value: 'International',
      icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "globe"
      })
    }];
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const highlight = option.checked ? ' highlight' : '';
      buttons.push(/*#__PURE__*/_jsxs("div", {
        className: "radiobutton-container",
        tabIndex: "0",
        onFocus: () => this.onFocus(option.value),
        onBlur: this.onBlur,
        children: [/*#__PURE__*/_jsx("input", {
          id: option.value,
          className: "radio-button-hidden",
          type: "radio",
          checked: option.checked,
          value: option.value,
          onChange: () => this.select(option.value)
        }), /*#__PURE__*/_jsxs("label", {
          htmlFor: option.value,
          children: [/*#__PURE__*/_jsx("div", {
            className: "radio-display",
            children: /*#__PURE__*/_jsx("div", {
              className: `inner${highlight}`
            })
          }), option.title]
        })]
      }, option.value));
    }
    if (buttons.length > 0) {
      return /*#__PURE__*/_jsxs("div", {
        className: "form-element-container Delivery",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "delivery-options",
          children: [/*#__PURE__*/_jsx("div", {
            className: "label title",
            children: "Deliver my IDP to an:"
          }), /*#__PURE__*/_jsx("div", {
            className: "radio-buttons",
            children: buttons
          })]
        }), licenceDelivery === 'Australian' ? /*#__PURE__*/_jsx(Info, {
          icon: "envelope",
          framed: true,
          info: DELIVERY_MSG.Australian
        }) : null]
      });
    }
    return null;
  }
}
_defineProperty(Delivery, "defaultProps", {
  addresses: {
    licenceDelivery: {
      value: 'Australia'
    }
  }
});
const mapStateToProps = ({
  addresses,
  postage
}) => {
  return {
    addresses,
    postage
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deliveryInt: value => {
      dispatch(deliveryInt(value));
    },
    setPostage: value => {
      dispatch(postage(value));
    }
  };
};
const VisibleDelivery = connect(mapStateToProps, mapDispatchToProps)(Delivery);
export default VisibleDelivery;